import { blogArticles } from '@/mocks/articles';
import { Link } from 'react-router-dom';

export default function ArticleGrid() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <span className="text-xs font-semibold text-primary-500 uppercase tracking-widest">kakobuy sheet blog</span>
          <h2 className="text-3xl md:text-5xl font-heading font-semibold text-foreground-950 mt-2 leading-tight">
            Przewodniki Zakupowe
          </h2>
          <h2 className="text-3xl md:text-5xl font-heading font-semibold text-foreground-950 leading-tight">
            <span className="italic handwritten text-primary-500 text-4xl md:text-6xl">& Rankingi 2026</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {blogArticles.map((article) => (
            <Link
              key={article.id}
              to={`/blog/${article.id}`}
              className="group cursor-pointer"
            >
              <div className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1">
                <div className="relative w-full h-[280px] overflow-hidden rounded-2xl">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-400 mt-2 line-clamp-2">
                    {article.excerpt}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}